// Packages Reducer

import { initializeState } from '../../../utilities/storageUtils';
import packagesActionTypes from './packages.types';
import { API_STATUS } from '../../../utilities/constants';

const INITIAL_STATE = {
  selectedPackages: [],
  packageAvailabilityList: [],
  packagesApiStatus: API_STATUS.IDLE,
  errorMessage: '',
  planPackages: [],
  uffActivities: null
};

const packagesReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case packagesActionTypes.SET_PACKAGES_PLAN_INFO_SUCCESS:
      return {
        ...state,
        planPackages: action.planPackages,
        uffActivities: action.uffActivities ?? null
      };
    // Get Package Availability SUCCESS
    case packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_SUCCESS:
      return {
        ...state,
        packageAvailabilityList: action.packageAvailabilityList,
        packagesApiStatus: API_STATUS.SUCCEEDED,
        errorMessage: ''
      };
    // Get Package Availability LOADING
    case packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_LOADING:
      return {
        ...state,
        packagesApiStatus: API_STATUS.LOADING
      };
    // Get Package Availability FAIL
    case packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_ERROR:
      return {
        ...state,
        packageAvailabilityList: [],
        packagesApiStatus: API_STATUS.ERROR,
        errorMessage: action.errorMessage
      };

    case packagesActionTypes.SET_SELECTED_PACKAGES:
    case packagesActionTypes.UPSERT_PACKAGES:
    case packagesActionTypes.DELETE_PACKAGES:
      return {
        ...state,
        selectedPackages: action.selectedPackages
      };
    case packagesActionTypes.CLEAR_PACKAGES_PLAN:
      return {
        ...state,
        selectedPackages: [],
        planPackages: [],
        uffActivities: null
      };

    default:
      return state;
  }
};

export default packagesReducer;
